import Swiper, { Navigation, Pagination } from 'swiper'
import 'swiper/swiper.min.css'
import 'swiper/modules/pagination/pagination.min.css'
import 'swiper/modules/navigation/navigation.min.css'

class ProductRecommendations {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._url = this._elem.dataset.recommendationsUrl
        this._slick_config = this._elem.dataset.slickConfig
    }

    onInit () {
        fetch(this._url)
            .then((response) => response.text())
            .then((text) => {
                const html = document.createElement('div')
                html.innerHTML = text
                const recommendations = html.querySelector(
                    '.product-recommendations'
                )

                if (
                    recommendations &&
                    recommendations.innerHTML.trim().length
                ) {
                    this._elem.innerHTML = recommendations.innerHTML
                }

                /* eslint-disable no-new */
                new Swiper(
                    this._elem.querySelector('[data-slick-element]'),
                    {
                        modules: [Navigation, Pagination],
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev'
                        },
                        slidesPerView: 1,
                        breakpoints: {
                            480: {
                                slidesPerView: 2,
                                spaceBetween: 20
                            },
                            640: {
                                slidesPerView: 3,
                                spaceBetween: 20
                            }
                        }
                    }
                )
            })
            .catch((e) => {
                console.error(e)
            })
    }
}

export default ProductRecommendations



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ProductRecommendations.js